import { Box, SxProps, Theme } from '@mui/material';
import type { KeyboardEvent } from 'react';

interface TouchBoxProps {
  sx?: SxProps<Theme>;
  onClick?: () => void;
  children?: React.ReactNode;
  [key: string]: unknown;
}

const TouchBox = ({ sx = {}, onClick, children, ...rest }: TouchBoxProps) => {
  const interactive = Boolean(onClick);

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (!onClick) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onClick();
  };

  return (
    <Box
      sx={{
        ...sx,
        ...(interactive
          ? {
              touchAction: 'manipulation',
              WebkitTapHighlightColor: 'transparent',
              cursor: 'pointer',
              userSelect: 'none',
            }
          : {}),
      }}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={interactive ? handleKeyDown : undefined}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default TouchBox;
